import { schema } from 'normalizr';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import accountSchema from './accountSchema';

const facebookPageSchema = new schema.Entity(
  'facebookPages',
  {
    account: accountSchema,
  },
  {
    processStrategy: (entity) => mapKeysToCamelCase(entity, true),
  }
);

export default facebookPageSchema;
